import styled from 'styled-components';

export const Wrapper = styled.div`
	margin: 2rem 0;
`;
